/**
 * Maps a channel ID to its corresponding feature name pattern.
 *
 * @param channel - The channel identifier (e.g., 'facebook', 'telegram', 'tiktok')
 * @returns The feature name in the format required for responder mapping
 *
 * @example
 * getChannelFeatureName('telegram') // returns 'telegram.dm.send'
 * getChannelFeatureName('facebook') // returns 'meta.facebook.dm.send'
 */
export const getChannelFeatureName = (channel: string): string => {
    const nonMetaPlatforms = ['tiktok', 'telegram'];

    if (nonMetaPlatforms.includes(channel)) {
        return `${channel}.dm.send`;
    }

    return `meta.${channel}.dm.send`;
};
